var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2676_7801",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2676_7801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 10C10.4583 10 10.8507 9.8368 11.1771 9.51041C11.5035 9.18403 11.6666 8.79166 11.6666 8.33333C11.6666 7.875 11.5035 7.48264 11.1771 7.15625C10.8507 6.82986 10.4583 6.66666 9.99998 6.66666C9.54165 6.66666 9.14929 6.82986 8.8229 7.15625C8.49651 7.48264 8.33331 7.875 8.33331 8.33333C8.33331 8.79166 8.49651 9.18403 8.8229 9.51041C9.14929 9.8368 9.54165 10 9.99998 10ZM9.99998 16.125C11.6944 14.5694 12.9514 13.1562 13.7708 11.8854C14.5903 10.6146 15 9.48611 15 8.5C15 6.98611 14.5173 5.74653 13.5521 4.78125C12.5868 3.81597 11.4028 3.33333 9.99998 3.33333C8.5972 3.33333 7.41317 3.81597 6.4479 4.78125C5.48262 5.74653 4.99998 6.98611 4.99998 8.5C4.99998 9.48611 5.4097 10.6146 6.22915 11.8854C7.04859 13.1562 8.30553 14.5694 9.99998 16.125ZM9.99998 18.3333C7.76387 16.4306 6.09373 14.6632 4.98956 13.0312C3.8854 11.3993 3.33331 9.88889 3.33331 8.5C3.33331 6.41666 4.00345 4.75694 5.34373 3.52083C6.68401 2.28472 8.23609 1.66666 9.99998 1.66666C11.7639 1.66666 13.316 2.28472 14.6562 3.52083C15.9965 4.75694 16.6666 6.41666 16.6666 8.5C16.6666 9.88889 16.1146 11.3993 15.0104 13.0312C13.9062 14.6632 12.2361 16.4306 9.99998 18.3333Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.9c9e4d8a2570cd1c8c9f618c803f12c3.svg";
export { ForwardRef as ReactComponent };